import { render } from "./CharacteristicsPanel.vue?vue&type=template&id=ebc282fe&scoped=true"
import script from "./CharacteristicsPanel.vue?vue&type=script&lang=js"
export * from "./CharacteristicsPanel.vue?vue&type=script&lang=js"

import "./CharacteristicsPanel.vue?vue&type=style&index=0&id=ebc282fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ebc282fe"

export default script